import * as React from 'react';
import { Badge, BadgeProps } from 'ui/badge/badge';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import styles from 'app/area/case/components/fact-box/fact-box.scss';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';

interface ConnectedCasesRiskFactItemProps extends ComponentProps, FactItemProps { 
  badgeProps: BadgeProps;
  section?: number;
  hideRiskWeight?: boolean;
  connectedRiskWeight: number;
  connectedRiskArea: ComplexValue<number>;
  connectedRiskTrend: ComplexValue<number>[];
}
export const ConnectedCasesRiskFactItem = (props: ConnectedCasesRiskFactItemProps) => {
  const { connectedRiskArea, connectedRiskTrend, connectedRiskWeight, url, title, linkDomain, urlOpenNew, hideRiskWeight } = props;
  const connectedCaseRiskProps = {
    title: title,
    tooltip: connectedRiskArea?.description,
    text: !hideRiskWeight ? connectedRiskWeight : '',
    filled: true,
    backgroundColor: connectedRiskArea?.backgroundColor,
    foregroundColor: connectedRiskArea?.foregroundColor,
    riskTrend: {
      value: connectedRiskTrend?.[0]?.value,
      description: connectedRiskTrend?.[0]?.description,
      icon: connectedRiskTrend?.[0]?.icon
    }
  };

  if (!connectedRiskWeight) {
    return null;
  }
  return (<li className={`${styles.factLink} fact-item`}>
    <FactLink id={props.componentId} classNames={styles.factLink} section={linkDomain} url={url} urlOpenNew={urlOpenNew}>
      <Badge
        {...connectedCaseRiskProps}
      />
    </FactLink> </li>
  );
};
